import React from "react";
import { useTranslation } from "react-i18next";
import FooterSection from '../../components/sections/FooterSection';

function ContactsPage(props) {

    var { t } = useTranslation();

    return (
        <>
        <div className="uk-margin-xlarge-bottom">

            {/* Panoramic header image */}
            <img
                src="/imgvideo/pano2.jpg"
                alt="Panorama"
                style={{
                    display: "block", width: "100%",
                    height: "27vh",
                    objectFit: "cover",
                    objectPosition: "top"
                }}
            />

            {/* Main content container */}
            <div className="uk-container uk-margin-top uk-margin-bottom">

                <h1 className="uk-margin-bottom">
                    {t("ui.pages.contacts")}
                </h1>

                <div className="uk-grid uk-child-width-1-2@s" data-uk-grid>

                    {/* Left Collumn */}
                    <div className="uk-flex-left">

                        {/* Buba */}
                        <div className="uk-grid-small uk-child-width-auto@s uk-flex-middle uk-margin-bottom" uk-grid="true">
                            <div>
                                <img
                                    src="/staff/buba.jpg"
                                    alt="Buba Jallow"
                                    className="uk-border-circle"
                                    style={{ width: "120px", height: "120px", objectFit: "cover" }}
                                />
                            </div>
                            <div className="uk-width-expand">
                                <h4>
                                    {t("company.staff.member.buba")} – {t("company.staff.role.ceo")}
                                </h4>
                                <p>
                                    <strong>Phone:</strong> <a href="tel:+77750912804">+7(775)091-2804</a><br />
                                    <strong>Email:</strong> <a href="mailto:buba@jai.com.kz">buba@jai.com.kz</a>
                                </p>
                            </div>
                        </div>

                        <hr className="uk-divider-small" />

                        {/* Wendy Caracessec */}
                        <div className="uk-grid-small uk-child-width-auto@s uk-flex-middle uk-margin-bottom" uk-grid="true">
                            <div>
                                <img
                                    src="/staff/wendy.jpg"
                                    alt="Bayandy Amanbekova"
                                    className="uk-border-circle"
                                    style={{ width: "120px", height: "120px", objectFit: "cover" }}
                                />
                            </div>
                            <div className="uk-width-expand">
                                <h4>
                                    {t("company.staff.member.bayan")} – {t("company.staff.role.coo")}
                                </h4>
                                <p>
                                    <strong>Phone:</strong> <a href="tel:+77475006901">+7(747)500-6901</a><br />
                                    <strong>Email:</strong> <a href="mailto:bayandy@jai.com.kz">bayandy@jai.com.kz</a>
                                </p>
                            </div>
                        </div>

                        <hr className="uk-divider-small" />

                        {/* Andrew Niy */}
                        <div className="uk-grid-small uk-child-width-auto@s uk-flex-middle uk-margin-bottom" uk-grid="true">
                            <div>
                                <img
                                    src="/staff/andrew.jpg"
                                    alt="Andrew Niy"
                                    className="uk-border-circle"
                                    style={{ width: "120px", height: "120px", objectFit: "cover" }}
                                />
                            </div>
                            <div className="uk-width-expand">
                                <h4>
                                    {t("company.staff.member.andrew")} – {t("company.staff.role.regdir")} ({t("company.cities.krg")})
                                </h4>
                                <p>
                                    <strong>Phone:</strong> <a href="tel:+77052487334">+7 (705)248-7334</a><br />
                                    <strong>Email:</strong> <a href="mailto:andrew@jai.com.kz">andrew@jai.com.kz</a>
                                </p>
                            </div>
                        </div>

                        <hr className="uk-divider-small" />

                        {/* Alan */}
                        <div className="uk-grid-small uk-child-width-auto@s uk-flex-middle uk-margin-bottom" uk-grid="true">
                            <div>
                                <img
                                    src="/staff/alan.jpg"
                                    alt="Alan Caracessec"
                                    className="uk-border-circle"
                                    style={{ width: "120px", height: "120px", objectFit: "cover" }}
                                />
                            </div>
                            <div className="uk-width-expand">
                                <h4>
                                    {t("company.staff.member.alan")} – {t("company.staff.role.cto")}
                                </h4>
                                <p>
                                    <strong>Phone:</strong> <a href="tel:+77471544504">+7(747)154-4504</a><br />
                                    <strong>Email:</strong> <a href="mailto:alan@jai.com.kz">alan@jai.com.kz</a>
                                </p>
                            </div>
                        </div>

                        <hr className="uk-divider-small" />

                        {/* Aibol Temirzhanov */}
                        <div className="uk-grid-small uk-child-width-auto@s uk-flex-middle uk-margin-bottom" uk-grid="true">
                            <div>
                                <img
                                    src="/staff/aibol.jpg"
                                    alt="Aibol Temirzhanov"
                                    className="uk-border-circle"
                                    style={{ width: "120px", height: "120px", objectFit: "cover" }}
                                />
                            </div>
                            <div className="uk-width-expand">
                                <h4>
                                    {t("company.staff.member.aibol")} – {t("company.staff.role.lawyer")}
                                </h4>
                                <p>
                                    <strong>Phone:</strong> <a href="tel:+77076750351">+7 (707)675-0351</a><br />
                                    <strong>Email:</strong> <a href="mailto:aibol@jai.com.kz">aibol@jai.com.kz</a>
                                </p>
                            </div>
                        </div>
                    </div>

                    {/* Right Collumn */}
                    <div className="uk-flex-right">

                        {/* Angie Reynolds */}
                        <div className="uk-grid-small uk-child-width-auto@s uk-flex-middle uk-margin-bottom" uk-grid="true">
                            <div>
                                <img
                                    src="/staff/angie.jpeg"
                                    alt="Angie Reynolds"
                                    className="uk-border-circle"
                                    style={{ width: "120px", height: "120px", objectFit: "cover" }}
                                />
                            </div>
                            <div className="uk-width-expand">
                                <h4>
                                    {t("company.staff.member.angie")} – {t("company.staff.role.smm")}
                                </h4>
                                <p>
                                    <strong>Phone:</strong> <a href="tel:+77476718233">+7(747)671-83-33</a><br />
                                    <strong>Email:</strong> <a href="mailto:angie@jai.com.kz">angie@jai.com.kz</a>
                                </p>
                            </div>
                        </div>                        

                        <hr className="uk-divider-small" />

                        {/* Alex Roberts */}
                        <div className="uk-grid-small uk-child-width-auto@s uk-flex-middle uk-margin-bottom" uk-grid="true">
                            <div>
                                <img
                                    src="/staff/alex.jpg"
                                    alt="Alexander P. A. Roberts"
                                    className="uk-border-circle"
                                    style={{ width: "120px", height: "120px", objectFit: "cover" }}
                                />
                            </div>
                            <div className="uk-width-expand">
                                <h4>
                                    {t("company.staff.member.alex")} – {t("company.staff.role.migration")}
                                </h4>
                                <p>
                                    <strong>Phone:</strong> <a href="tel:+77080613817">+7 (708)061-3817</a><br />
                                    <strong>Email:</strong> <a href="mailto:alex@jai.com.kz">alex@jai.com.kz</a>
                                </p>
                            </div>
                        </div>                        

                        <hr className="uk-divider-small" />

                        {/* Kwame Danso */}
                        <div className="uk-grid-small uk-child-width-auto@s uk-flex-middle uk-margin-bottom" uk-grid="true">
                            <div>
                                <img
                                    src="/staff/kwame.jpg"
                                    alt="Kwame Danso"
                                    className="uk-border-circle"
                                    style={{ width: "120px", height: "120px", objectFit: "cover" }}
                                />
                            </div>
                            <div className="uk-width-expand">
                                <h4>
                                    {t("company.staff.member.kwame")} – {t("company.staff.role.migration")}
                                </h4>
                                <p>
                                    <strong>Phone:</strong> <a href="tel:+77082338790">+7 (708)233-8790</a><br />
                                    <strong>Email:</strong> <a href="mailto:kwame@jai.com.kz">kwame@jai.com.kz</a>
                                </p>
                            </div>
                        </div>

                        <hr className="uk-divider-small" />

                        {/* Jankie Duysenbayev */}
                        <div className="uk-grid-small uk-child-width-auto@s uk-flex-middle uk-margin-bottom" uk-grid="true">
                            <div>
                                <img
                                    src="/staff/jankie.jpeg"
                                    alt="Jankie Duisenbayev"
                                    className="uk-border-circle"
                                    style={{ width: "120px", height: "120px", objectFit: "cover" }}
                                />
                            </div>
                            <div className="uk-width-expand">
                                <h4>
                                    {t("company.staff.member.zhank")} – {t("company.staff.role.cameraman")}
                                </h4>
                                <p>
                                    <strong>Phone:</strong> <a href="tel:+77755937604">+7(775)593-7604</a><br />
                                    <strong>Email:</strong> <a href="mailto:zhankeldy@jai.com.kz">zhankeldy@jai.com.kz</a>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
        <FooterSection />
        </>
    );
}

export default ContactsPage;
